module.exports = "/_next/static/images/ankeet-da945d9c46f1d81cb099d0ceab34c285.png";